/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { MutableRefObject, useEffect } from 'react';

const useFocusIn = (ref: MutableRefObject<HTMLElement | null>, callback: (e: Event) => void) => {
  useEffect(() => {
    const current = ref.current || window;
    current.addEventListener('focusin', callback);
    return () => {
      current.removeEventListener('focusin', callback);
    };
  }, [ref, callback]);
};

export default useFocusIn;
